/**
 * Monitors Page - Automated Compliance Verification Checks
 */
import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Plus, RefreshCw, Zap } from 'lucide-react';
import { Card, Badge } from '../components/ui-custom/ComplianceUI';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function MonitorsPage() {
  const [monitors, setMonitors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMonitors = async () => {
      try {
        const response = await fetch(`${API_URL}/api/monitors/?limit=50`, {
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setMonitors(data.monitors || []);
        }
      } catch (error) {
        console.error('Failed to fetch monitors:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchMonitors();
  }, []);

  const handleTrigger = async (monitorId) => {
    try {
      const response = await fetch(`${API_URL}/api/monitors/${monitorId}/trigger`, {
        method: 'POST',
        credentials: 'include',
      });
      if (response.ok) {
        toast.success('Monitor triggered');
      }
    } catch (error) {
      toast.error('Failed to trigger monitor');
    }
  };

  return (
    <div className="monitors-page">
      <div className="page-header">
        <div>
          <h1>Compliance Monitors</h1>
          <p>Automated compliance verification checks</p>
        </div>
        <button className="btn-primary" data-testid="create-monitor-btn">
          <Plus size={16} /> Create Monitor
        </button>
      </div>

      {loading ? (
        <div className="loading-container"><div className="spinner" /></div>
      ) : monitors.length > 0 ? (
        <div className="monitors-list">
          {monitors.map((monitor) => (
            <Card key={monitor.monitor_id} className="monitor-card">
              <div className="monitor-info">
                <div className="monitor-id">{monitor.monitor_id}</div>
                <div className="monitor-name">{monitor.name}</div>
                <div className="monitor-type">{monitor.monitor_type?.replace(/_/g, ' ')}</div>
              </div>
              <Badge color={monitor.status === 'active' ? "#059669" : "#6b7280"}>
                {monitor.status}
              </Badge>
              <button className="link-btn" onClick={() => handleTrigger(monitor.monitor_id)}>
                <RefreshCw size={14} /> Run
              </button>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="empty-state">
          <Zap size={48} color="#6b7280" />
          <h3>No monitors configured</h3>
          <p>Configure automated monitors once connector credentials (Plaid, Stripe, GitHub, hosting) are provided.</p>
        </Card>
      )}
    </div>
  );
}
